import { render } from "./Register.vue?vue&type=template&id=10a22144"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Register.vue?vue&type=style&index=0&id=10a22144&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__